import { useClickListener } from 'lib/events-framework'
import { FC, useCallback, useRef } from 'react'
import styled from 'styled-components'

export type Props = {
  onCoverClick?(): void
}

export const PopupCover: FC<Props> = ({ children, onCoverClick }) => {
  const coverRef = useRef<HTMLDivElement>(null)

  const clickHandler = useCallback((e) => {
    const classList = e.target.classList
    const isOverlay = Object.values(classList)

    if ((e.target.parentNode === e.currentTarget || isOverlay.find((item) => item === 'js-wrapper')) && onCoverClick)
      onCoverClick()
  }, [])

  useClickListener(coverRef, clickHandler)

  return (
    <Wrapper>
      <Cover ref={coverRef}>{children}</Cover>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
`

const Cover = styled.div`
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
`
